export default "__VITE_ASSET__DImn1SbA__"